<template>
  <div class="chart-wrapper">
    <apexchart type="line" height="100%" :options="chartOptions" :series="chartSeries"></apexchart>
  </div>
</template>

<script>
export default {
  name: "SpeedChart",
  props: {
    velocityData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartSeries() {
      return [
        {
          name: "Exzentrisch (runter)",
          data: this.velocityData.map((v) => (v < 0 ? Math.abs(v) : null)),
        },
        {
          name: "Konzentrisch (hoch)",
          data: this.velocityData.map((v) => (v >= 0 ? Math.abs(v) : null)),
        },
      ]
    },
    chartOptions() {
      return {
        chart: {
          height: "100%",
          type: "line",
          toolbar: { show: false },
          animations: { enabled: false },
        },
        colors: ["#FF5252", "#4CAF50"],
        stroke: { curve: "smooth", width: 3 },
        grid: { show: false },
        tooltip: { enabled: false },
        xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
        yaxis: { show: false, min: 0, max: 2.5 },
        legend: { show: false },
        markers: { size: 0 },
      }
    },
  },
}
</script>

<style scoped>
.chart-wrapper {
  height: 100%;
  width: 100%;
}
</style>
